import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  lat= 23.162268;
  lng= 79.959728;

  email:string='';
  exampleForm: FormGroup;
  validation_messages = {
    'uname': [
      { type: 'required', message: 'E-mail is required!' }
    ],
    'phn': [
      { type: 'required', message: 'Phone Number is required!' }
    ]
  };

  constructor(private fb: FormBuilder, private fs:FirebaseService) {
    const user = JSON.parse(localStorage.getItem('user'));
    if(user){
      this.email=user.email;
    }
   }

  ngOnInit(): void {
    this.createForm();
  }

  
  createForm(){
    this.exampleForm = this.fb.group({
      uname: [this.email, Validators.required ],
      phn: ['', Validators.required ],
      message:['']
    });
  }

  
  resetFields(){
    this.exampleForm = this.fb.group({
      uname: new FormControl('', Validators.required),
      phm: new FormControl('', Validators.required),
      message: new FormControl('')
    });
  }

  goSubmit(value){
    this.fs.addMessage(value);
    alert("Message sent!");
    this.resetFields();
  }

}
